import React from "react";

const TabPanel = ({ value, index, children }) => value === index && children;

export default TabPanel;
